import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../component/common/CustomPagination";
import { koKRGrid } from "../../component/common/TableKRText";
import api from "../../../API";
import { useSelector } from "react-redux";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import ScriptFileDetailDialog from "./ScriptFileDetailDialog";


function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function CustomToolbar(props: any) {

  // console.log('CustomToolbar props :::: ' , props)

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>검색 총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
        <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 목록 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>처리구분</Box>
        <Select id="scriptState" value={props.scriptState} onChange={(e)=>props.setScriptState(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"스크립트제출"}>스크립트제출</MenuItem>
          <MenuItem dense value={"스크립트부적합"}>스크립트부적합</MenuItem>
          <MenuItem dense value={"스크립트검토완료"}>스크립트검토완료</MenuItem>
          {/* <MenuItem dense value={"샘플반려"}>샘플반려</MenuItem>
          <MenuItem dense value={"검사완료"}>검사완료</MenuItem> */}
        </Select>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>업로드일자</Box>
        <TextField size="small" id="uploadDate" value={props.uploadDate} onChange={(e)=>props.setUploadDate(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />
        {/* <Button variant="contained" onClick={()=>props.setUploadParam()}>검색</Button> */}
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>이름</Box>
        <TextField size="small" id="scriptState" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}
        <Button variant="contained" onClick={()=>{props.setUploadParam(); }}>검색</Button>
        
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface ScriptFileType {
  idx: number;
  mgm_con_pk: string;
  did: string;
  content_type: string;
  email: string;
  name: string;
  origin_file_name: string;
  file_dir: string;
  file_type: string;
  extension: string;
  state: string;
  ins_date: string;
  reject_rsn : string;
  upload_date: string;
  ki_doc: object | null;
  // sttsrt: [];
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}


const ScriptFileListPage = (props:any) => {

  const [page, setPage] = useState(1);

  const [scriptState, setScriptState] = useState('모두');
  const [uploadDate, setUploadDate] = useState('');

  // const [worker, setWorker] = useState('');

  const [p_uploadDate, setP_uploadDate] = useState('');
  // const [p_worker, setP_worker] = useState('');

  const setUploadParam = () => {
    setP_uploadDate(uploadDate);
  }

  // const setWorkerParam = () => {
  //   setP_worker(worker);
  // }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<ScriptFileType>({
    idx: 0,
    mgm_con_pk: "",
    did: "",
    content_type: "",
    email: "",
    name: "",
    origin_file_name: "",
    file_dir: "",
    file_type: "",
    extension: "",
    state: "",
    ins_date: "",
    reject_rsn : "",
    upload_date: "",
    ki_doc: null,
    // sttsrt: [],
    
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const scriptFileUploadListByUser = async (state:string,uploadDate:string) => {
    var result = await api.get("/scriptFileUploadListByUser", {
      params: {page:page,state:(state ? state: "모두"),uploadDate:(p_uploadDate ? p_uploadDate: ""),worker:email}
    });
    console.log("스크립트 파일 리스트", result.data.datas);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        idx: data.idx,
        mgm_con_pk: data.mgm_con_pk,
        did: data.did,
        content_type: data.content_type,
        email: data.email,
        name: data.name,
        origin_file_name: data.origin_file_name,
        file_dir: data.file_dir,
        file_type: data.file_type,
        extension: data.extension,
        state: data.state,
        ins_date: data.ins_date,
        reject_rsn : data.reject_rsn,
        upload_date: data.upload_date,
        ki_doc: data.ki_doc,
        // sttsrt: data.sttsrt
      };
    });

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    setTotalCount(result.data.pagination.total_count);
    // console.log("data", result.data.datas);
  };

  const searchScriptFileList = props.searchScriptFileList

  if(searchScriptFileList){
    scriptFileUploadListByUser(scriptState,p_uploadDate);
    props.setSearchScriptFileList(false)
  }

  useEffect(() => {
    scriptFileUploadListByUser(scriptState,p_uploadDate);
  }, [scriptState,p_uploadDate,page]);

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const columns: GridColDef[] = [
    { field: "idx", headerName: "순번", headerAlign: "center", width: 84,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>순번</Box>
      )
    },
    // {
    //   field: "email", headerName: "이메일", headerAlign: "center", headerClassName: "header-style", width: 180,
    //   preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
    //     const isValid = validateEmail(params.props.value);
    //     return { ...params.props, error: !isValid };
    //   },
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이메일</Box>
    //   ),
    //   renderCell: (params:any) => (
    //     <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
    //   ),
    // },
    // { field: "name", headerName: "이름", headerAlign: "center", width: 100,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이름</Box>
    //   ),
    //   renderCell: (params:any) => (
    //     <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
    //   ),
    // },
    { field: "mgm_con_pk", headerName: "스크립트PK", headerAlign: "center", width: 130,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>스크립트PK</Box>
      ),
    },
    { field: "origin_file_name", headerName: "원본파일명", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>원본파일명</Box>
      ),
    },
    // { field: "file_dir", headerName: "파일위치", headerAlign: "center", width: 300,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>파일위치</Box>
    //   ),
    // },
    // { field: "file_type", headerName: "파일종류", headerAlign: "center", width: 100,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>파일종류</Box>
    //   ),
    // },
    { field: "upload_date", headerName: "업로드일자", headerAlign: "center", width: 120,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>업로드일자</Box>
      ),
    },
    { field: "ins_date", headerName: "업로드시간", headerAlign: "center", width: 180,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>업로드시간</Box>
      ),
    },
    { field: "state", headerName: "처리상태", headerAlign: "center", width: 120,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>처리상태</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{color:"#fff"}}>
          <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (params.value === "스크립트부적합" ? "#c09c24" : (params.value === "스크립트검토완료" ? "#1152a7":"#3fb92e"))}}>{params.value}</Button>  
        </Box>
      ),
    },
    // { field: "reject_rsn", headerName: "반려사유", headerAlign: "center", width: 200,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>반려사유</Box>
    //   ),
    //   renderCell: (params:any) => (
    //     <Box sx={{fontWeight:700, fontSize:"12px"}}>{params.value == "None"?  "" : params.value}</Box>
    //   ),
    // },
  ];

  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    // console.log('handleSelectionModelChange    id ??? ' , ids)
    console.log('체크박스 idx , ', ids)
    setSelectCheckCnt(ids.length)
    // setSelectedWorkers(ids);
  };

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>스크립트 - 제출 리스트</h3></Box>
        <Box sx={{ height: "600px", width: "100%" }}>
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                totalCount:totalCount,
                scriptState: scriptState,
                setScriptState: setScriptState,
                uploadDate: uploadDate,
                setUploadDate: setUploadDate,
                setUploadParam: setUploadParam,
                selectCheckCnt: selectCheckCnt,
                // worker: worker,
                // setWorker: setWorker,
                // setWorkerParam: setWorkerParam,
              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // onFilterModelChange={handleFilterModelChange}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {dialogOpen == true ? (
        <ScriptFileDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          scriptFileUploadListByUser={scriptFileUploadListByUser}
          scriptState={scriptState}
          p_uploadDate={p_uploadDate}
          // p_worker={p_worker}
          
        />
      ) : ""}
    </Box>
  );
};

export default ScriptFileListPage;
